import React from 'react';

const About = () => {
  return (
    <section id="about" className="bg-background py-16 md:py-24 px-6 md:px-10 border-t border-slate-200/60">
      <div className="max-w-4xl mx-auto">
        <p className="text-xl md:text-2xl lg:text-3xl font-medium text-text-primary leading-relaxed text-center">
          We help teams design, implement, and optimize internal systems that support efficient and reliable business operations through technical consulting, systems implementation, workflow automation, and custom integrations.
        </p>
      </div>
    </section>
  );
};

export default About;
